import React from 'react';

type KwPanelProps = {
  onClick?: () => void;
  className?: string;
  testId?: string;
  children: React.ReactNode;
};

const KwPanel = ({ onClick, className, testId, children }: KwPanelProps) => (
  <div
    onClick={onClick}
    className={`panel kw-panel r-corners-sm-up flex-grow-1 ${className ?? ''}`}
    data-cy={testId}
  >
    {children}
  </div>
);
export default KwPanel;
